import React, { Component } from "react";
import { oops, not_found, not_found_description } from "../../resources/string/strings"
import { connect } from "react-redux";
import { isLogin } from "../../authentication/authorizer";

class NotFound extends Component {
  state = {
    pageTitle: "404 - صفحه یافت نشد",
    pageTag: "not-found",
  };

  componentDidMount() {
    document.title = this.state.pageTitle;
    if (isLogin() !== "true") {
        this.goToAuthentication()
    }
  }

  render() {
    return (
      <div className="fragment text-center row">
        <div
          className="mx-auto text-center p-3  col-11 col-sm-11 col-md-8 col-lg-6 col-xl-5"
        >
          {this.props.login.isLogin === "true" &&
            <div>

              <div
                style={{
                  fontSize: 100,
                  fontWeight: "bold",
                  color: "var(--colorPrimary)",
                }}
                className="col-12 m-0 p-0"
              >
                {oops}
              </div>

              <div
                style={{
                  fontSize: 26,
                }}
                className="col-12 m-0 p-0"
              >
                {not_found}
              </div>

              <div
                style={{
                  whiteSpace: "pre-wrap",
                  fontSize: 13,
                }}
                className="col-12 mt-3 p-0"
              >
                {not_found_description}
              </div>
            </div>
          }

        </div>
      </div>
    );
  }


  goToAuthentication = () => {
    this.props.history.push("/authenticationHome");
  }
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

export default connect(mapStateToProps)(NotFound);
